<template>
  <div style="background-color:#fff;min-height:500px;padding:40px">
    <div style="display:flex;align-items:center;height:40px;margin-bottom:20px">
      <div style="flex:1;font-size: 16px;color: #666666;">申请退货</div>

      <el-button v-if="status == 1" type="primary" icon="el-icon-service"  style="margin-right:20px;background-color:#fff;color:#f90000">联系客服</el-button>
    </div>

    <div v-if="status == 1">

      <div style="padding:35px 0 14px;font-size: 16px;color: #999999">申请信息</div>
      <div style="border:1px solid #e4e4e4;padding:30px">
        <el-form :model="form" ref="form" label-width="130px" :rules="rules" class="demo-ruleForm">
          <el-form-item label="提交数量" prop="age">
            <el-input-number :max='obj.goodsquantity' :min='1' v-model="form.quantity" label="" size="small"></el-input-number>
            <span style="color:gray;margin-left:10px;font-size: 12px;color: #999999 ">您最多可提交数量为{{ obj.goodsquantity }}个</span>
          </el-form-item>
          <el-form-item label="退货原因" prop="returnType">
            <el-select v-model="form.returnType" placeholder="请选择"
            @change='radioChange'
            >
              <el-option
                v-for="item in options"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="安装时间" prop="installationDay">
            <el-date-picker
                    v-model="form.installationDay"
                    type="date" value-format="yyyy-MM-dd"
                    placeholder="选择安装时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="安装后行驶公里" prop="mileage">
            <el-input placeholder="请输入安装后行驶公里" maxlength="10" v-model="form.mileage">
              <template slot="append">公里</template>
            </el-input>
          </el-form-item>


          <el-form-item label="具体描述" prop="remark">
            <el-input v-model="form.remark" placeholder="请输入问题描述" type="textarea"
            :autosize="{ minRows: 5}"
            ></el-input>
          </el-form-item>

          <el-form-item label="上传照片" prop="age">
            <el-upload
              :action=" publicUrl + '/api/user/upload' "
              list-type="picture-card"
              :on-remove="handleReturnPicRemove"
              :on-success="handleReturnPicSuccess"
              :data="updata"
              :file-list="returnPic"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <div style="font-size: 12px;color: #999999 ;margin-bottom:10px;text-indent:100px;font-weight:700">
            {{  remarkDesc  }}
          </div>
          <div
            style="font-size: 12px;color: #f90000;;margin-bottom:24px;text-indent:100px"
          >最多可上传9张图片，每张图片大小不超过5M，支持bmp,gif,jpg,png,jpeg格式文件</div>

          <el-form-item style="text-align:center;margin-top:40px;display:flex;justify-content:center">

            <div
              class="background_style btn"
              :style="{backgroundImage: 'url(' + btn_red + ')' }"
              style="width:178px;height: 50px;line-height: 50px;cursor : pointer"
              @click.stop="submitForm('form')"
            >
              确认提交
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <div v-else-if="status  == 2 " style="display:flex;align-items:center;flex-direction:column;min-height:600px;padding:20px 0">
      <div style="border-bottom:2px solid #e6e6e6;width:100%;margin-bottom:80px"></div>
      <div >
        <i class="el-icon-circle-check" style="font-size:80px;color:#f90000"></i>
      </div>

      <div style="margin-top:15px;margin-bottom:10px;font-size: 24px;color: #666666;">售后申请提交成功</div>
      <div style="font-size: 16px;color: #999999 ">售后专员可能与您电话沟通，请保持手机畅通</div>
      <div style="text-align:center;margin-top:25px">
        <router-link to="/user/aftersale" tag="div">
          <div
            class="background_style btn"
            :style="{backgroundImage: 'url(' + btn_red + ')' }"
            style="width:178px;height: 50px;line-height: 50px;"
          >
            返回
          </div>
        </router-link>
      </div>

      <div style="border:1px solid #e6e6e6;background-color:#f2f2f2; width:calc(100% - 120px );padding:20px;margin-top:100px;color:gray;font-size:14px">
        <div style="margin-bottom:10px;font-size: 14px;font-weight: 700;color: #999999 "><i class="el-icon-warning-outline" ></i> 温馨提示：</div>
        <div style="margin-bottom:10px;font-size: 14px;color: #999999">
          • 商品寄回地址将在审核通过后以短信形式告知，或在申请记录中查询。
        </div>
        <div style="margin-bottom:10px;font-size: 14px;color: #999999">
          • 提交服务单后，售后专员可能与您电话沟通，请保持手机畅通。
        </div>
        <div style="margin-bottom:10px;font-size: 14px;color: #999999">
          • 退货处理成功后退款金额将原路返回到您的支付账户中；
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { getDictDataReq } from '@/api/common/index'
import { supplementOrderAfterSaleReq , addOrderAfterSaleReq , orderAfterSaleDetailReq , getAfterSaleQuantityReq  } from '@/api/afterSale/index'


export default {
  data() {
    return {
      publicUrl : this.common.publicUrl ,
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,

      rules: {
        returnType: [
          { required: true, message: '请选择退货原因', trigger: 'change' },
        ],
        installationDay : [
          { required: true, message: '请选择安装时间', trigger: 'blur' },
        ],
        mileage : [
          { required: true, message: '请输入安装后行驶公里', trigger: 'blur' },
        ],
        remark : [
          { required: true, message: '请输入问题描述', trigger: 'blur' },
        ]
      },

      updata : {
        type : JSON.stringify(2)
      },
      obj : {

      } ,
      status: 1, //第一步
      dialogImageUrl: "",
      input3: "",
      tableData: [],
      options: [],
      form: {
        age: "",
        returnType : '' ,
        remark : "" ,
        quantity : 1 ,
      },
      returnPic : [

      ] , //退货图片
      remarkDesc : '' ,
    };
  },

  methods: {
    //跳转至申请页
    // applyAftersaleClick(){
    //   this.$emit('routerChange', 'toApplyAftersale');
    // },
    //补充资料
    supplementOrderAfterSale(query){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
      supplementOrderAfterSaleReq(query).then( res => {
        if(res.data.status == 0) {
          loading.close( )
          //申请成功
          let obj = {}
          obj.id = res.data.id
          obj.orderGoodsId = this.obj.orderGoodsId
          obj.orderNo = this.obj.orderNo

          let params = JSON.stringify( obj )
          this.$router.replace({
            path: '/user/aftersaleDetail',
            query: {
              params : params
            }
          })
        }else{
          loading.close( )
          this.$message({
            message: res.data.statusDesc,
            type: 'warning'
          });
        }
      })
    },
    //提交申请
    addOrderAfterSale(query){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)'
      });
      addOrderAfterSaleReq(query).then( res => {
        if(res.data.status == 0) {
          loading.close( )
          //申请成功
          let obj = {}
          obj.id = res.data.id
          obj.orderGoodsId = this.obj.orderGoodsId
          obj.orderNo = this.obj.orderNo

          let params = JSON.stringify( obj )
          this.$router.replace({
            path: '/user/aftersaleDetail',
            query: {
              params : params
            }
          })
        }else{
          loading.close( )
          this.$message({
            message: res.data.statusDesc,
            type: 'warning'
          });
        }
      })
    },
    //提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if( this.returnPic.length <= 0 ){
            this.$message({
              message: '请选择退货图片',
              type: 'warning'
            });
            return false;
          }

          let url = ''
          let query = { }
          query.returnType = this.form.returnType
          query.remark = this.form.remark
          query.quantity = this.form.quantity
          query.installationDay = this.form.installationDay
          query.mileage = this.form.mileage

          let returnPicArr = []
          this.returnPic.forEach( val => {
            returnPicArr.push( val.uploadUrl )
          })
          query.returnPic = returnPicArr.join(',')
          query.orderGoodsId = this.obj.orderGoodsId
          query.orderNo = this.obj.orderNo
          query.id = this.obj.aftersaleId ? this.obj.aftersaleId : ''

          if( this.obj.aftersaleId ){ //补充资料
            this.supplementOrderAfterSale(query)
          }else{
            this.addOrderAfterSale(query)
          }


        } else {
          return false;
        }
      });
      // this.status = 2
      // window.scrollTo( 0 , 0 )
    },
    radioChange(e){
      //单选框改变
      // console.log( e )
      this.options.forEach( val => {
        if( val.dictValue == e ){
          this.remarkDesc = val.remark
        }
      })
    },
    //图片上传成功
    handleReturnPicSuccess(res, file){
      if( res.status == 0 ){ //上传成功
        this.returnPic.push({
          url : this.publicUrl  + res.filePath,
          uploadUrl  : res.filePath
        })
      }
    },
    //图片删除
    handleReturnPicRemove( file, fileList ){
      // console.log(file)
      // console.log(  fileList )
    },
    resetForm() {
      // this.$refs[formName].resetFields();
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //获取选项数据
    getDictData( type ){
      getDictDataReq({
        dictType : type
      }).then( res => {
        if (res.data.status == 0) {
          let attr = type + 'Options'
          this.options = res.data.list
          if( this.obj.aftersaleId ){
            this.orderAfterSaleDetail()
          }
        }
      })
    },
    //售后明细
    orderAfterSaleDetail(){
      // console.log( '还原数据' )
      orderAfterSaleDetailReq({
        id : this.obj.aftersaleId ,
        orderGoodsId : this.obj.orderGoodsId ,
        orderNo : this.obj.orderNo
      }).then( res => {
        if (res.data.status == 0) {
          this.address = res.data.address ? res.data.address : ''
          this.name = res.data.name ? res.data.name : ''
          this.phone = res.data.phone ? res.data.phone : ''
          res.data.orderAfterSale.returnPic.split(',').forEach( val=>{
            this.returnPic.push({
              url : this.publicUrl  + val,
              uploadUrl  : val
            })
          })

          this.form = res.data.orderAfterSale
          this.options.forEach( val => {
            if( val.dictValue == this.form.returnType ){
              this.remarkDesc = val.remark
            }
          })

        }
      } )

    }
  },
  created(){
    let obj =  JSON.parse( this.$route.query.params )
    this.obj = obj
    getAfterSaleQuantityReq({
      orderGoodsId :  this.obj.orderGoodsId
    }).then( res => {
      if (res.data.status == 0) {
        this.obj.goodsquantity = res.data.afterSaleQuantity
      }else{
        this.$message({
          message: res.data.statusDesc,
          type: 'warning'
        });
      }
    })


    this.getDictData( 'returnType' )

  },
};
</script>

<style scoped>
.border-right:not(:last-child) {
  border-right: 1px solid #ededed;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
